module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opinion d-flex"
  }, [_c('div', [_c('img', {
    staticClass: "opinion-avatar",
    attrs: {
      "src": _vm.opinion.additionalInformation.customerImage,
      "alt": _vm.opinion.additionalInformation.name
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('p', {
    staticClass: "opinion-name"
  }, [_vm._v(_vm._s(_vm.opinion.additionalInformation.name))]), _vm._v(" "), _c('img', {
    staticClass: "mr-2 opinion-nationality",
    attrs: {
      "src": _vm.opinion.nationality,
      "alt": _vm.opinion.nationality
    }
  }), _vm._v(" "), _c('div', [_c('el-rate', {
    attrs: {
      "colors": _vm.colors,
      "disabled": ""
    },
    model: {
      value: (_vm.opinion.rating),
      callback: function($$v) {
        _vm.$set(_vm.opinion, "rating", $$v)
      },
      expression: "opinion.rating"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "opinion-text"
  }, [_vm._v(_vm._s(_vm.opinion.description))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-542e1123","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/opinion.vue
// module id = 1117
// module chunks = 1